// extracted by mini-css-extract-plugin
export var activeDot = "_2g-c";
export var buttonContainer = "_2g-9";
export var channelButton = "_2g-a";
export var clickable = "_2g-d";
export var content = "_2g-0";
export var contentFull = "_2g-2";
export var contentThird = "_2g-1";
export var contentWrapper = "_2g-7";
export var description = "_2g-5";
export var heightShort = "_2g-f";
export var image = "_2g-3";
export var imageContainer = "_2g-4";
export var selectButton = "_2g-e";
export var spinnerContainer = "_2g-b";
export var titleContent = "_2g-8";
export var titleWrapper = "_2g-6";